import React from 'react';

import { Button, Stack, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

export const ALREADY_PURCHASED_MESSAGE =
  "You can't purchase this package because it has already been purchased once by you.";

interface IAlreadyPurchasedNoticeProps {
  browseTo?: string;
}

const AlreadyPurchasedNotice = ({
  browseTo = '/packages/sales-portal',
}: IAlreadyPurchasedNoticeProps): JSX.Element => (
  <Stack align='center' spacing='xs' p='md'>
    <Text ta='center'>{ALREADY_PURCHASED_MESSAGE}</Text>
    <Button component={Link} to={browseTo}>
      Browse other packages
    </Button>
  </Stack>
);

export default AlreadyPurchasedNotice;
